import http from "./http";
import apis from "../config/apis.json";

const api = 
    process.env.REACT_APP_ENVIRON === "development"
    ? apis.dev
    : process.env.REACT_APP_ENVIRON === "production"
    ? apis.prod
    : apis.test;

// GA4 OAuth Service Functions
export async function getGA4Status(organizationId) {
    const response = await http.get(`${api}/ga4/${organizationId}/oauth/status`);
    return response;
}

export async function initiateGA4OAuth(organizationId) {
    const response = await http.post(`${api}/ga4/${organizationId}/oauth/initiate`);
    return response;
}

export async function disconnectGA4(organizationId) {
    const response = await http.delete(`${api}/ga4/${organizationId}/oauth/disconnect`);
    return response;
}

export async function updateGA4Property(organizationId, propertyId, propertyName) {
    const response = await http.put(`${api}/ga4/${organizationId}/oauth/property`, {
        propertyId,
        propertyName
    });
    return response;
}

// Analytics Service Functions
export async function getOverviewReport(organizationId) {
    const response = await http.get(`${api}/ga4/${organizationId}/tools/overview-report`);
    return response;
}

// Google Search Console OAuth Service Functions
export async function getGSCStatus(organizationId) {
    const response = await http.get(`${api}/gsc/${organizationId}/oauth/status`);
    return response;
}

export async function initiateGSCOAuth(organizationId) {
    const response = await http.post(`${api}/gsc/${organizationId}/oauth/initiate`);
    return response;
}

export async function disconnectGSC(organizationId) {
    const response = await http.delete(`${api}/gsc/${organizationId}/oauth/disconnect`);
    return response;
}

export async function updateGSCSite(organizationId, siteUrl, siteDisplayName) {
    const response = await http.put(`${api}/gsc/${organizationId}/oauth/site`, {
        siteUrl,
        siteDisplayName
    });
    return response;
}

// Google Search Console Tools Service Functions
export async function getGSCOverviewReport(organizationId) {
    const response = await http.get(`${api}/gsc/${organizationId}/tools/overview-report`);
    return response;
}